/**
 * Aggregates experience and transfer line-item totals keyed by bundle id so
 * accommodation payment totals can include bundled amounts that are excluded
 * from standalone experience/transfer totals.
 */
export function buildBundledExperienceTotalsById(
  experienceItems: Array<App.Checkout.ExperienceItemView>,
  transferItems: Array<App.Checkout.TransferItemView> = [],
): Record<string, { price: number, memberPrice: number }> {
  const bundledExperienceTotalsById: Record<string, { price: number, memberPrice: number }> = {}
  for (const view of [...experienceItems, ...transferItems]) {
    if (!view.item.isAccomBundle) continue
    const bundleId = view.item.isAccomBundle
    const existing = bundledExperienceTotalsById[bundleId] ?? { price: 0, memberPrice: 0 }
    bundledExperienceTotalsById[bundleId] = {
      price: existing.price + (view.totals.price ?? 0),
      memberPrice: existing.memberPrice + (view.totals.memberPrice ?? 0),
    }
  }
  return bundledExperienceTotalsById
}
